import { Keyboard } from 'react-native';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { KeyboardAvoiding } from 'shared/src/component';
import { isIOS } from 'shared/src/utils';
import { useUpdateFolder } from '../../../queries/useUpdateFolder';
import { FolderNameEditor } from '../components/FolderNameEditor';

export const useRenameFolderBottomSheet = createUseBottomSheetModal<
  { folderSno: number; folderName: string },
  { sno: number; initialTitle: string; coverImage: string | null }
>(({ confirm, cancel, param }) => {
  const { mutateAsync: updateFolder } = useUpdateFolder();
  const { bottom, top } = useSafeArea();
  const { height: screenHeight } = useScreenSize();

  const sheet = (
    <BottomSheetContainer
      onPressClose={() => {
        Keyboard.dismiss();
        cancel();
      }}
      minHeight={isIOS ? (screenHeight - bottom - top) / 3 : 0}
      title="서랍 이름 바꾸기"
    >
      <FolderNameEditor
        initialValue={param.initialTitle}
        validate={value => value.length > 0 && value !== param.initialTitle}
        onSubmit={async value => {
          await updateFolder({
            sno: param.sno,
            title: value,
            image: param.coverImage,
          });
          confirm({ folderSno: param.sno, folderName: value });
        }}
        onClose={cancel}
      />
    </BottomSheetContainer>
  );

  // 웹 분기는 KeyboardAvoiding(shared) 안에 있다 — 웹에선 no-op.
  return <KeyboardAvoiding>{sheet}</KeyboardAvoiding>;
});
